import type { FinanceReport } from '../api';
import { formatMinor } from '../format';

export function ReceiptChart({report,currency}:{report:FinanceReport;currency:string}) {
  const receipts=new Map<string,bigint>();
  for(const row of report.dailyReceipts) if(row.currency===currency&&row.date>=report.from&&row.date<=report.to) {
    receipts.set(row.date,(receipts.get(row.date)??0n)+BigInt(row.amountMinor));
  }
  const values:{date:string;amount:bigint}[]=[];
  const last=new Date(`${report.to}T00:00:00Z`);
  for(const date=new Date(`${report.from}T00:00:00Z`);date<=last;date.setUTCDate(date.getUTCDate()+1)) {
    const key=date.toISOString().slice(0,10);
    values.push({date:key,amount:receipts.get(key)??0n});
  }
  const max=values.reduce((value,row)=>row.amount>value?row.amount:value,0n);
  const min=values.reduce((value,row)=>row.amount<value?row.amount:value,0n);
  const range=max-min||1n;
  const percent=(value:bigint)=>Number(value*10000n/range)/100;
  const labelEvery=Math.max(1,Math.ceil(values.length/5));
  return <>
    <div className="finance-chart-scroll"><figure className="overview-chart-wrap finance-chart" aria-label={`Поступления по дням, ${report.from} — ${report.to}, ${currency}`} style={{minWidth:Math.max(450,values.length*15+150)}}>
      <div className="overview-chart-axis"><span>{formatMinor(max.toString(),currency)}</span><span>{formatMinor(((max+min)/2n).toString(),currency)}</span><span>{formatMinor(min.toString(),currency)}</span></div>
      <div className="overview-chart"><i className="overview-gridline top"/><i className="overview-gridline middle"/><i className="overview-gridline bottom"/>{min<0n&&max>0n&&<i className="finance-zero-line" style={{bottom:`${percent(-min)}%`}}/>}
        {values.map(({date,amount},index)=><div key={date} className="overview-bar-column" tabIndex={0} aria-label={`${date}: ${formatMinor(amount.toString(),currency)}`} title={`${date}: ${formatMinor(amount.toString(),currency)}`}>
          <div className={`overview-chart-bar${amount<0n?' finance-chart-negative':''}`} style={{height:amount===0n?'2px':`${Math.max(.5,percent(amount<0n?-amount:amount))}%`,bottom:`${percent(amount<0n?amount-min:-min)}%`,opacity:amount===0n?.18:1}}/>
          <span className="overview-day-label">{index%labelEvery===0||index===values.length-1?(report.from.slice(0,7)===report.to.slice(0,7)?Number(date.slice(8)):`${date.slice(8)}.${date.slice(5,7)}`):''}</span>
        </div>)}
      </div>
    </figure></div>
    {values.every(row=>row.amount===0n)&&<p className="finance-chart-empty">Поступлений нет.</p>}
    <div className="overview-chart-summary"><span>{report.from} — {report.to}</span><span>{report.timezone} · {currency}</span></div>
  </>;
}
